export const WAGMI_SCOPE_KEYS = {
  SKILLS_URI: 'SKILLS_URI',
  SKILLS_CONTRACT: 'SKILLS_CONTRACT',
  SKILLS_BALANCE_OF_BATCH: 'SKILLS_BALANCE_OF_BATCH',
  SKILLS_BALANCE_OF_BATCH_FROM_METADATA: 'SKILLS_BALANCE_OF_BATCH_FROM_METADATA',
  COLLECTIONS_MANAGER_TOTAL_SUPPLY: 'COLLECTIONS_MANAGER_TOTAL_SUPPLY'
}
